import React, { useEffect, useState } from 'react' //lazy
import { useDispatch, useSelector } from 'react-redux'
import { getListCasino, getListSlot } from 'apis'
import { TemplateMypage } from 'templates'
import line1ImgVs2 from 'assets/images/Line1-vs2.png'
import line2ImgVs2 from 'assets/images/Line2-vs2.png'
import homeBanner from 'assets/images/home/home-banner.png'
import homeBanner1 from 'assets/images/home/home-banner1.png'
import homeBanner2 from 'assets/images/home/home-banner2.jpg'
import homeBannerBlow from 'assets/images/home/jackpot.png'
import BackThumbailCasino from 'assets/images/BackThumbailCasino.jpg'
import BackThumnailSlot from 'assets/images/BackThumnailSlot.jpg'
import BoxItem from './BoxItem'

/** Call API */
import // dadasdsa
'apis'

import * as S from './style'

import { isEmptyObject } from 'utils/ref'

function HomePage(): React.ReactElement {
  const dispatch = useDispatch()
  const [gameMain, setGameMain] = useState<any>([])
  const [slotMain, setSlotMain] = useState<any>([])

  const userData = useSelector((state: any) => state.user)

  const getGamesMain = async () => {

    dispatch({ type: 'WAITTING' })
    try {
      const res: any = await getListCasino()
      if (res.result === false) {
        alert(res.message)
        dispatch({ type: 'STOP_WAITTING' })
      } else {
        setSlotMain(res)
        dispatch({ type: 'STOP_WAITTING' })
      }
    } catch (error) {
      console.log(error)
      dispatch({ type: 'STOP_WAITTING' })
    }
  }
  const getSlotMain = async () => {
    dispatch({ type: 'WAITTING' })
    try {
      const res: any = await getListSlot()
      if (res.result === false) {
        alert(res.message)
        dispatch({ type: 'STOP_WAITTING' })
      } else {
        setGameMain(res)
        dispatch({ type: 'STOP_WAITTING' })
      }
    } catch (error) {
      console.log(error)
      dispatch({ type: 'STOP_WAITTING' })
    }
  }

  useEffect(() => {
    getGamesMain()
    getSlotMain()
    // getMe(dispatch)
  }, [isEmptyObject(userData.dataUser)])

  useEffect(() => {
    setOdometer()
  }, [])

  function setOdometer() {
    // eslint-disable-next-line prefer-const
    let e = document.querySelector('#odometer1'),
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      a: any = new Date().getTime() + ''
    ;(a = a.substring(2, 12) / 10 + ''), (a = Number(a) + 7e6)

    const n = new Odometer({
      el: e,
      value: a,
      format: '(,ddd).dd',
      theme: 'minimal'
    })
    setInterval(function () {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      let e: any = new Date().getTime() + ''
      ;(e = e.substring(2, 12) / 10 + ''), (e = Number(e) + 7e6)
      Math.floor(100 * e)
      ;(e = $.number(e, 2)),
        0 === parseInt(e.substr(e.length - 1, 1)) &&
          (e = $.number(Number(e.toString().replace(/,/gi, '')) + 0.01, 2)),
        n.update(e)
    }, 2133)
  }

  return (
    <TemplateMypage>
      <S.SliderContent>
        <img src={homeBanner} alt='' />
        {/* <img src={homeBanner2} alt='' /> */}
      </S.SliderContent>
      <S.Banner>
        <img src={homeBannerBlow} alt='' />
        <div className='num'>
          <span id='odometer1'></span>
        </div>
      </S.Banner>
      <BoxItem
        img={line1ImgVs2}
        data={slotMain}
        category='liveCasino'
        page={'casino'}
        imgBackThumbail={BackThumbailCasino}
      />
      <BoxItem
        img={line2ImgVs2}
        data={gameMain}
        category='liveCasino'
        imgBackThumbail={BackThumnailSlot}
        page={'slot'}
      />
    </TemplateMypage>
  )
}

export default HomePage
